import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import type { Locale } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type CountryOfBirthFieldProps = {
  locale: Locale;
  disabled?: boolean;
};
export const CountryOfBirthField = t0 => {
  const $ = _c(16);
  const {
    locale,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.fields.usLegalStatus.countryOfBirth"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = diToFormData("id.nationality");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = {
      required: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp2);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp3);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== disabled || $[11] !== locale || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <Form.Country data-dd-privacy="mask" name={t2} disabled={disabled} rules={t4} label={t5} placeholder={t6} testID="nationality-select" locale={locale} />;
    $[10] = disabled;
    $[11] = locale;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
function _temp($) {
  return $.error;
}
function _temp2($_0) {
  return $_0.label;
}
function _temp3($_1) {
  return $_1.placeholder;
}